<app-ice-radio-list-item
  testId="voice-offerings-list-item-input"
  [control]="control"
  [disabled]="isDisabled"
  [label]="mobilePlanProduct?.productName"
  [matTooltip]="tooltipMessage"
  [value]="offering.id"
>
  <div inlineContent>
    <div class="price">
      @if (
        mobilePlanProduct.monthlyPrice?.isDiscounted &&
        mobilePlanProduct.monthlyPrice.originalPrice?.includingVAT > mobilePlanProduct.monthlyPrice.price?.includingVAT
      ) {
        <span class="campaign-original-price">
          {{ mobilePlanProduct.monthlyPrice.originalPrice | priceFormat: PriceType.OneTime }}
        </span>
      }
      <span class="monthly-price">{{ mobilePlanProduct?.monthlyPrice?.price | priceFormat: PriceType.Monthly }}</span>
    </div>
  </div>
  <div class="header" content>
    <div class="subscription-binding-period">
      @if (offering.bindings?.length > 0) {
        m/startbrudd
        @if (offering.bindings[0].terminationFee) {
          {{ offering.bindings[0].terminationFee | priceFormat: PriceType.OneTime }}
        }
        <app-ice-info-icon [tooltip]="Messages.TerminationFee" />
      } @else {
        @if (existingBindingWillBeTransferred) {
          Viderefører avtaletid til {{ SubscriptionBindingExpirationDate(assignedSubscription) | date: 'dd.MM.yyyy' }}
        } @else {
          <div>ingen avtaletid</div>
        }
      }
    </div>
    @if (changeInfo?.triggersBreakageFee) {
      <div class="breakage-fee-message">
        <div class="change-subscription">
          {{ changeInfo.remainingBreakageFee | priceFormat: PriceType.OneTime }} i bruddgebyr
        </div>
      </div>
    }

    @if (offering.monthlyPrice?.isCampaign && offering.monthlyPrice?.campaignPeriod > 0) {
      <app-ice-badge class="additional-information" type="neutral">
        Rabatt i {{ offering.monthlyPrice.campaignPeriod }} måneder
      </app-ice-badge>
    }
    <app-ice-pill class="additional-information" type="neutral" [isInteractive]="false">
      {{ vasProduct?.productName }}
      @if (vasProduct?.monthlyPrice?.price?.includingVAT > 0) {
        <span>&ensp;+</span>
      }
      <span>{{ vasProduct?.monthlyPrice?.price | priceFormat: PriceType.Monthly : 'Inkludert' }}</span>
    </app-ice-pill>
    @if (control.value === offering.id) {
      <app-unique-selling-points class="unique-selling-points" [VASProductName]="vasProduct?.productName" />
    }
  </div>
  @if (control.value === offering.id) {
    <app-unique-selling-points class="unique-selling-points" [VASProductName]="vasProduct?.productName" />
  }
</app-ice-radio-list-item>
